import React, {useContext, useState, useEffect, useReducer} from 'react';

import useApi from '../Hooks/useApi'
import Loader from '../Components/Loader'
import {AuthContext} from './../context/AuthContext'

const Guidelines = (props) => {
    const {userInfo} = useContext(AuthContext);


  return (
    <>

    
                            <div className="content">
                                <div className="header">
                                    <label className="title"> Guidelines </label>
                                </div>
                                <div className="body">
                                    <div className="animate-bottom">
                                        <div className='col-12'>
                                            <p className='fw-bold'>If you have any query, contact Mr. Irfan (Database Administrator and Incharge Registraitons) at 0300-8026530 </p>
                                        </div>
                                        <hr></hr>
                                        <div className='col-12'>
                                            <p>You can <span className='fw-bold'> apply for Registrations till {userInfo.portalLockDate} </span> after that the portal will be locked  </p>
                                        </div>
                                        <div className='col-12'>
                                            <p> You wil be able to <span className='fw-bold'> generate the Fee Challans and Pay Registration Fee till {userInfo.feeDueDate}. No manual fee through bank draft will be accepted. </span>.   </p>
                                        </div>
                                        <div className='col-12'>
                                            <p>After {userInfo.feeDueDate}, You will be able to <span className='fw-bold'> Print the list of students whose fee is paid in 'Print Applications' </span> for submission to the office of Punjab Medical Faulty on Covering Letter Head with sign and stamp of the Principal/MS/Head of Institute . </p>
                                        </div>
                                        <div className='col-12'>
                                            <p>Document of your students will be start scrutinizing after {userInfo.feeDueDate}. You are required to <span className='fw-bold'>check the 'Objections' Menu on Daily Basis</span> for timely removal of objections (if any). No Removal of Objection will be enteratined after <span className='fw-bold'>{userInfo.objectionRemovalDate}</span>    </p>
                                        </div>
                                        <div className='col-12'>
                                            <p>List of <span className='fw-bold'>Accepted Students will be dsiplayed in 'Registered Students' menu </span> which will be eligible to appear in the next Annual Examination    </p>
                                        </div>



                                    </div>


                                    
                                </div>
                            </div>
    </>
  );

};

export default Guidelines;